import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { CardLoader } from 'components/loaders'
import { AddLog, EditLog, SignOff } from 'containers/forms/dashboard'
import { AssessorSummary } from 'components/sections/assessor'
import { LogDetail } from 'components/sections/dashboard'
import { LogCard, BadgeLogCard } from 'components/sections/activity'
import {
  ElevatedButton,
  FixedRightBottom,
  Placeholders,
  Logs
} from 'components/layout'
import modals from 'constants/layout/modals'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import { modal } from 'helpers/decorators'
import { ACTIVITY_STATES, LEVELS, ROLES } from 'constants/enums'
import { createSortLogs } from 'helpers/sorting'
import { getSignupRole } from 'utils/token'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import AcceptActivity from '../../forms/dashboard/AcceptActivity/AcceptActivity'
import { AddLogs } from '../../forms/dashboard'
import styles from '../ActivityLogs/activity-logs.styl'


// Create unique sortLogs memoized function for each use case separately
let sortLogs

@apiDashboard.apiActivity()
@apiDashboard.apiActivityLogs()
@modal.trigger()
@injectIntl
@apiConfiguration()
@connect(({ api, auth }) => ({
  files: api.files,
  user: auth.user,
  isFileUploading: api.blob.loading,
  awardBadges: api.badges.awardBadges,
  configuration: api.configuration,
  award: api.dashboard.awards.awards.data
}))
class ActivityLogs extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
    onAddLog: PropTypes.func.isRequired,
    onAddLogs: PropTypes.func.isRequired,
    onEditLog: PropTypes.func.isRequired,
    onGetLogs: PropTypes.func.isRequired,
    onDeleteLog: PropTypes.func.isRequired,
    activityUploadReport: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    activity: PropTypes.object,
    modalObj: PropTypes.object,
    params: PropTypes.object,
    activityLogs: PropTypes.object,
    files: PropTypes.object,
    isFileUploading: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isAssessor: PropTypes.bool,
    intl: PropTypes.object,
    user: PropTypes.object,
    awardBadges: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    award: PropTypes.object.isRequired
  }

  componentWillMount = async() => {
    const { params, award, activity } = this.props

    sortLogs = createSortLogs()

    if (params && params.activityId) {
      this.handleLoadLogs(params.activityId)
    }

    const orgId = get(award, 'organization.id') || get(activity, 'assessor.organization.id')
    await this.loadCustomization(orgId)
  }

  componentWillReceiveProps = async(nextProps) => {

    if (get(this.props, 'activity.id') !== get(nextProps, 'activity.id')) {
      const orgId = get(nextProps, 'activity.assessor.organization.id')
      await this.loadCustomization(orgId)
    }

    if (get(this.props, 'award.organization.id') !== get(nextProps, 'award.organization.id')) {
      const orgId = get(nextProps, 'award.organization.id')
      await this.loadCustomization(orgId)
    }
  }

  loadCustomization = async (orgId) => {
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, orgId, true)
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsEnabled.id, orgId, true)
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id, orgId, true)
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id, orgId, true)
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id, orgId, true)
  }

  componentWillUpdate(nextProps) {
    const { params } = this.props

    if (
      get(params, 'activityId') &&
      get(params, 'activityId') !== get(nextProps.params, 'activityId')
    ) {
      this.handleLoadLogs(get(nextProps.params, 'activityId'))
    }
  }

  handleLoadLogs = activityId => this.props.onGetLogs(activityId)

  handleOpenAddLog = () => this.props.onOpen(modals.ADD_LOG)
  handleOpenAddLogs = () => this.props.onOpen(modals.ADD_LOGS)
  handleOpenSignOff = () => this.props.onOpen(modals.SIGN_OFF)
  handleOpenAcceptActivity = () => this.props.onOpen(modals.ACCEPT_ACTIVITY)

  handleOpenEditLog = log =>
    this.props.onOpen(modals.EDIT_LOG, null, {
      log: { ...log, activity: this.props.activity }
    })

  handleOpenLogDetail = log =>
    this.props.onOpen(modals.LOG_DETAIL, null, {
      log: { ...log, activity: this.props.activity }
    })

  createBadgeLogs = (awardBadgesBySection, award) => {
    const badgeLogs = []

    const filteredBadges = awardBadgesBySection && awardBadgesBySection.filter(a => get(a, 'award.awardLevel.value') === get(award, 'awardLevel.value'))

    filteredBadges && filteredBadges.forEach(b => {
      badgeLogs.push({
        id: get(b, 'id'),
        activity: get(b, 'activity'),
        date: get(b, 'obtainedDate'),
        createdAt: get(b, 'createdAt'),
        createdBy: get(b, 'createdBy'),
        deleted: get(b, 'deleted'),
        modifiedAt: get(b, 'modifiedAt'),
        modifiedBy: get(b, 'modifiedBy'),
        version: get(b, 'version'),
        createdByPerson: get(b, 'createdByPerson'),
        duration: 0,
        description: '',
        fileUrls: [],
        isMigrated: false,
        isBadgeLog: true,
        badge: get(b, 'badge')
      })
    })
    return badgeLogs
  }

  getBulkLogsForAward = awardLevel => {
    switch(awardLevel){

      case LEVELS.BRONZE.id: return get(this.props,`configuration.values.${CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id}.booleanValue`)
      case LEVELS.SILVER.id: return get(this.props,`configuration.values.${CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id}.booleanValue`)
      case LEVELS.GOLD.id: return get(this.props,`configuration.values.${CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id}.booleanValue`)
      default: return false
    }
  }

  renderLogs = (logs, activitySection, award) => {
    const awardBadges = this.props.awardBadges

    const awardBadgesBySection = awardBadges.filter(ab => get(ab, 'activitySection.value') === activitySection)

    const isBadgesEnabled = get(this.props.configuration, `values[${CONFIGURATION_KEYS.isBadgesEnabled.id}].booleanValue`)

    const isBadgesStrictModeEnabled = get(this.props.configuration, `values[${CONFIGURATION_KEYS.isBadgesStrictModeEnabled.id}].booleanValue`)

    if(isBadgesEnabled) {
      const badgeLogs = this.createBadgeLogs(awardBadgesBySection,award)

      logs = logs.concat(badgeLogs)
      logs = logs.sort((a, b) => new Date(get(a, 'date')) - new Date(get(b, 'date')))
    }

    return (logs && logs.length > 0
      ? logs
        .map(item => (
          <Logs.Item key={item.id}>
            {item.isBadgeLog &&
            <BadgeLogCard
              award={award}
              activity={this.props.activity}
              modal={this.props.onOpen}
              log={item}
              activitySection={get(
                this.props.activity,
                'activitySection.value'
              )}
              onOpenDetail={this.handleOpenLogDetail}
              files={this.props.files}
              isBadgesStrictModeEnabled={isBadgesStrictModeEnabled}
              id={item.id}
            /> ||
            <LogCard
              log={item}
              activitySection={get(
                this.props.activity,
                'activitySection.value'
              )}
              onOpenDetail={this.handleOpenLogDetail}
              files={this.props.files}
            /> }
          </Logs.Item>
        ))
        .reverse()
      : <Placeholders.LogsPlaceholder
        isAssessor={this.props.isAssessor}
        customMessage={this.props.intl.formatMessage({
          id: 'label.participants_has_no_logs',
          defaultMessage: 'Participant has no logs yet.'
        })}
      />)
  }

  render() {
    const {
      activity,
      modalObj,
      onAddLog,
      onEditLog,
      onDeleteLog,
      params,
      activityLogs,
      isReadOnly,
      isAssessor,
      isFileUploading,
      user,
      award,
      onAddLogs
    } = this.props

    const awardLevel = get(award, 'awardLevel.value')
    const isBulkLogsEnabled = get(this.props,`configuration.values.${CONFIGURATION_KEYS.isBulkLogsEnabled.id}.booleanValue`)
    const isBulkLogsForAwardEnabled = this.getBulkLogsForAward(awardLevel)
    const isBulkLogEnabled = get(award, 'isBulkLogEnabled')
    const logs = sortLogs(get(activityLogs, 'data'))
    const loading = get(activityLogs, 'loading')
    const activitySection = get(activity, 'activitySection.value')
    const state = get(activity, 'activityState.value') || get(activity, 'value')
    const colorClass = getActivityClassName(activitySection)
    const editable = state === ACTIVITY_STATES.in_progress.id && !isReadOnly && !isAssessor
    const logDetail = get(modalObj, 'data.log')

    const logEditInitialValues = logDetail && {
      ...logDetail,
      fileUrls: logDetail.fileUrls &&
        logDetail.fileUrls.map(item => ({ url: item })),
      duration: logDetail.duration / 60
    }

    const setup = get(activity, 'isAcceptedByAssessor') === false
      && state === ACTIVITY_STATES.in_progress.id &&
      getSignupRole(user) === ROLES.ASSESSOR.u


    const signoffable =
      get(activity, 'isAssessmentPositive') === false &&
      state === ACTIVITY_STATES.assessment.id &&
      getSignupRole(user) === ROLES.ASSESSOR.u

    const isAssessmentState =
      state === ACTIVITY_STATES.assessment.id &&
      get(activity, 'isAssessmentPositive') === false

    const isAssessorReportAdditionalInfoEnabled = get(this.props,`configuration.values.${CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id}.booleanValue`)

    return (
      <div>
        {isAssessor && <div className={styles.logsDescription}>
          <FormattedMessage
            id="label.assessor_logs_multiple_activity_desc"
            defaultMessage="The progress bar and hours complete are cumulative across all activities a Participant undertakes
             for a Section. If the logs visible to you don't reflect the progress bar and hours completed,
             this Participant has multiple activities for this Section. You will only see the logs for the activity
             you are assessing."
          />
        </div>}
      <Logs.Wrap>
        {isAssessmentState && !isAssessor &&
        <AssessorSummary
          activityId={get(activity, 'id')}
          activityUploadReport={this.props.activityUploadReport}
        />}
        {loading ? <CardLoader logs /> : this.renderLogs(logs, activitySection, award)}
        {editable &&
        <FixedRightBottom>
          {isBulkLogsEnabled && isBulkLogsForAwardEnabled && isBulkLogEnabled && <ElevatedButton
            onClick={this.handleOpenAddLogs}
            colorClass={colorClass}
            intlKey="button.bulk_logs"
            dataTestId="addLogButtonSelector"
            high
            large
            oval
            uppercase
            addIcon
          >
            Bulk logs
          </ElevatedButton>}
          <br />
          <ElevatedButton
            onClick={this.handleOpenAddLog}
            colorClass={colorClass}
            intlKey="button.add_log"
            dataTestId="addLogButtonSelector"
            high
            large
            oval
            uppercase
            addIcon
          >
            Add log
          </ElevatedButton>
        </FixedRightBottom>}
        {signoffable &&
        <FixedRightBottom>
          <ElevatedButton
            onClick={this.handleOpenSignOff}
            colorClass={colorClass}
            intlKey="button.sign_off_dashed"
            high
            large
            oval
            uppercase
          >
            Sign off
          </ElevatedButton>
        </FixedRightBottom>}
        {setup &&
        <FixedRightBottom>
          <ElevatedButton
            onClick={this.handleOpenAcceptActivity}
            colorClass={colorClass}
            intlKey="label.accept_becoming_assessor"
            high
            large
            oval
            uppercase
          >
            Become the assessor
          </ElevatedButton>
        </FixedRightBottom>}
        {editable &&
        <AddLog
          activityId={params.activityId}
          colorClass={colorClass}
          onAddLog={onAddLog}
          modalId={modals.ADD_LOG}
          submitDisabled={isFileUploading}
        />}
        {editable &&
          <AddLogs
            activityId={params.activityId}
            colorClass={colorClass}
            onAddLogs={onAddLogs}
            modalId={modals.ADD_LOGS}
            submitDisabled={isFileUploading}
          />}
        {editable &&
        logDetail &&
        <EditLog
          activityId={params.activityId}
          colorClass={colorClass}
          onEditLog={onEditLog}
          modalId={modals.EDIT_LOG}
          initialValues={logEditInitialValues}
        />}
        {signoffable &&
        <SignOff
          colorClass={colorClass}
          id={params.activityId}
          activitySection={activitySection}
          modalId={modals.SIGN_OFF}
          actionId={get(activity, 'activityAssessmentRequestActionId')}
          isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
          isActivityRequest
        />}
        {setup &&
        <AcceptActivity
          colorClass={colorClass}
          id={params.activityId}
          modalId={modals.ACCEPT_ACTIVITY}
          isActivityRequest
        />}
        <LogDetail
          onOpenEditLog={this.handleOpenEditLog}
          onDeleteLog={onDeleteLog}
          modalId={modals.LOG_DETAIL}
          colorClass={colorClass}
          editable={editable}
          log={logDetail}
        />
      </Logs.Wrap>
      </div>
    )
  }
}

export default ActivityLogs
